<template>
  <div class="container">
    <div class="head">
      <div class="my flex">
        <button @click="goback" class="return">
          <img src="@/assets/images/left-arrow.png" alt="">
        </button>
        <!-- <img src="@/assets/imagess/head.png" class="huo" mode="" @click="handleImageClick"> -->
        <div class="right">
          <div class="num">购物商城</div>
          <!-- <div class="points-balance">购物TND:{{ points }}</div> -->
        </div>
      </div>
    </div>
    <div class="cont">
      <!-- 商品区：图片和信息左右布局，对齐参考图 -->
      <div class="product">
        <div class="image-container">
          <button @click="prevImage" class="nav-btn left" aria-label="上一张">‹</button>
          <img :src="currentImage" alt="Product Image" class="product-image">
          <button @click="nextImage" class="nav-btn right" aria-label="下一张">›</button>
        </div>

        <div class="product-details">
          <div class="info-item">
            <span class="label">商品名称</span>
          </div>
          <div class="info-item">
            <span class="value">{{ currentProduct.title }}</span>
          </div>
          <div class="info-item">
            <span class="label">扣除:</span>
            <span class="points-value">{{ currentProduct.price }} TND</span>
          </div>
        </div>
      </div>

      <!-- 收货信息区：居中标题 + 表单 -->
      <div class="shipping-info">
        <h2>收货信息</h2>
        <div class="form-group">
          <label>商品信息:</label>
          <input type="text" v-model="currentProduct.title" readonly class="product-info-input">
        </div>
        <div class="form-group">
          <label>收货地址:</label>
          <input type="text" v-model="address" placeholder="">
        </div>
        <div class="form-group">
          <label>收货姓名:</label>
          <input type="text" v-model="name" placeholder="">
        </div>
        <div class="form-group">
          <label>电话号码:</label>
          <input type="tel" v-model="phone" placeholder="">
        </div>
        <div class="form-group">
          <label>快递编号:</label>
          <input type="text" v-model="message" placeholder="仅商家发货后提供快递编号" class="message-input" readonly>
        </div>
      </div>

      <!-- 提示文字 -->
      <div class="logistics-info">
        <p v-if="hasSubmittedOrder">订单已提交，物流信息将在发货后更新。</p>
        <p v-else-if="isNewUser">首次购买，请填写收货信息后提交订单。</p>
        <p v-else>您可以修改收货信息或购买其他商品。</p>
      </div>

      <!-- 提交按钮 -->
      <button @click="submitOrder" class="submit-order"
        :disabled="points < currentProduct.price || !walletAddress">
        {{ hasSubmittedOrder ? '修改订单并重新提交' : '提交订单' }}
      </button>
      
      <button @click="resetForm" class="reset-order" v-if="hasSubmittedOrder">
        重置表单
      </button>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'shoppingMall',
  data() {
    return {
      quantity: 1,
      name: '',
      phone: '',
      address: '',
      message: '',
      hasSubmittedOrder: false,
      points: 0,
      loading: false,
      isNewUser: true,

      imageIndex: 0,
      imageList: [
        { image: require("@/assets/imagess/dk.png"), title: "神舟奇监测监测手表", price: 52 },
        { image: require("@/assets/imagess/dk2.png"), title: "AI手表助眠仪", price: 42 },
        { image: require("@/assets/imagess/dk3.png"), title: "强肾补阳手环", price: 35 },
        { image: require("@/assets/imagess/dk4.png"), title: "UV蓝光护目眼镜", price: 38 },        
        { image: require("@/assets/imagess/dk5.png"), title: "太赫兹能量项链", price: 98 },
        { image: require("@/assets/imagess/dk6.png"), title: "生物光子能量晶体", price: 113 },
        { image: require("@/assets/imagess/dk7.png"), title: "新一代胶原前体科技AKG", price: 120 },
        { image: require("@/assets/imagess/xys.png"), title: "西洋參濃縮液", price: 40 },
        { image: require("@/assets/imagess/sq.png"), title: "PT幹細胞肽", price: 300 },
      ],

      walletAddress: '',
      memberStatus: '未连接钱包',
    };
  },
  computed: {
    currentImage() {
      return this.imageList[this.imageIndex].image;
    },
    currentProduct() {
      return this.imageList[this.imageIndex];
    }
  },
  mounted() {
    this.loadPoints();
    this.memberStatus = '未连接钱包';
    this.connectWallet();
  },
  beforeDestroy() {
    this.savePoints();
  },
  methods: {
    loadPoints() {
      const saved = localStorage.getItem('userPoints');
      this.points = saved ? parseInt(saved, 10) : 0;
    },
    savePoints() {
      localStorage.setItem('userPoints', this.points.toString());
    },
    goback() {
      this.$router.go(-1);
    },
    prevImage() {
      this.imageIndex = (this.imageIndex - 1 + this.imageList.length) % this.imageList.length;
    },
    nextImage() {
      this.imageIndex = (this.imageIndex + 1) % this.imageList.length;
    },
    async connectWallet() {
      try {
        if (typeof window.ethereum === 'undefined') {
          throw new Error('未检测到钱包插件，请安装 MetaMask');
        }
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const walletAddress = await signer.getAddress();
        this.walletAddress = walletAddress;
        const contract = new ethers.Contract(contractAddress, contractABI, signer);
        const contractOwner = await contract.getOwner();
        if (walletAddress.toLowerCase() === contractOwner.toLowerCase()) {
          this.memberStatus = 'Deployer';
        } else {
          this.memberStatus = 'Member';
        }
        await this.loadUserAddress();
      } catch (error) {
        console.error('连接钱包失败:', error);
        this.memberStatus = '连接失败';
      }
    },
    handleImageClick() {
      if (this.memberStatus === '未连接钱包' || this.memberStatus === '连接失败') {
        this.connectWallet();
        return;
      }
      if (this.memberStatus === 'Deployer') {
        this.$router.push({ name: 'admin' });
      } else {
        alert('You do not have permission to access the admin page');
      }
    },
    async loadUserAddress() {
      if (!this.walletAddress) return;
      try {
        this.loading = true;
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress, contractABI, signer);
        const userRecords = await contract.getAllUserAddresses();
        if (userRecords.length > 0) {
          const latestRecord = userRecords[userRecords.length - 1];
          this.address = latestRecord.addressInfo;
          this.name = latestRecord.name;
          this.phone = latestRecord.phoneNumber;
          this.message = latestRecord.message;
          this.isNewUser = false;
        } else {
          this.address = '';
          this.name = '';
          this.phone = '';
          this.message = '';
          this.isNewUser = true;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.isNewUser = true;
      }
    },
    async saveAddress() {
      if (!this.walletAddress) return false;
      if (!this.name || !this.phone || !this.address) return false;
      try {
        this.loading = true;
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress, contractABI, signer);
        const tx = await contract.storeAddress(
          this.address,
          this.currentProduct.title,
          this.name,
          this.phone
        );
        await tx.wait();
        this.loading = false;
        return true;
      } catch (error) {
        this.loading = false;
        return false;
      }
    },
    resetForm() {
      this.address = '';
      this.name = '';
      this.phone = '';
      this.message = '';
      this.hasSubmittedOrder = false;
    },
    async submitOrder() {
      if (!this.walletAddress) return alert('请先连接钱包');
      if (!this.name || !this.phone || !this.address) return alert('请填写完整的收货信息');
      if (this.points < this.currentProduct.price) return alert(`TND不足！`);
      if (!confirm(`确定提交订单？`)) return;
      try {
        this.loading = true;
        const saveSuccess = await this.saveAddress();
        if (!saveSuccess) {
          this.loading = false;
          return;
        }
        this.points -= this.currentProduct.price;
        this.savePoints();
        this.hasSubmittedOrder = true;
        this.loading = false;
        alert('订单提交成功！');
      } catch (error) {
        this.points += this.currentProduct.price;
        this.savePoints();
        this.loading = false;
        alert('提交失败，TND已返还');
      }
    }
  }
};
</script>

<style scoped>
/* 基础布局 */
.flex {
  display: flex;
}

/* 头部样式（保持不变） */
.head {
  width: 100%;
  height: 0px;
  background: url(@/assets/imagess/bj.png) no-repeat;
  background-size: 100% 100%;
  padding-top: 150px;
  position: relative;
  box-sizing: border-box;
}

.head .my {
  margin-left: 101px;
}

.head .my .huo {
  width: 93px;
  height: 104px;
  cursor: pointer;
}

.head .my .return {
  position: absolute;
  top: 30px;
  left: 30px;
  background-color: #e7c71757;
  padding: 10px;
  border: none;
  border-radius: 15px;
}

.head .my .return img {
  width: 40px;
  height: 40px;
}

.head .my .right {
  margin-left: 29px;
  margin-top: -10px;
}

.head .my .right .num {
  font-size: 58px;
  color: #fff;
  font-weight: bold;
}

.head .my .right .points-balance {
  font-size: 40px;
  color: #b2dd17;
}

/* 主体内容容器 */
.cont {
  width: 100%;
  background:#FFFFFF;;
 
  box-shadow: 0px -27px 81px 0px rgba(0, 0, 0, 0.02);
  border-radius: 35px 35px 0px 0px;
  margin-top: -28px;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  height: 760px;
}

/* 商品区布局：图片+信息左右排列 */
.cont .product {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.cont .image-container {
  position: relative;
  width: 200px;
  height: 200px;
  flex-shrink: 0;
}

.cont .product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.cont .nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  z-index: 10;
  
}

.cont .nav-btn.left {
  left: -35px;
}

.cont .nav-btn.right {
  right: -35px;
}

/* 商品信息区样式，对齐参考图 */
.cont .product-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  text-align: center;
  margin-left: 30px; /* 👈 加这一行，往右挪 20px */
}

.cont .product-details .info-item .label {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.cont .product-details .info-item .value {
  font-size: 14px;
  color: #666;
}

.cont .product-details .points-value {
  font-size: 14px;
  color: #333;
}

/* 收货信息区 */
.cont .shipping-info {
  margin-bottom: 20px;
}

.cont .shipping-info h2 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0;
}

.cont .form-group {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.cont .form-group label {
  width: 100px;
  font-size: 16px;
  color: #333;
  flex-shrink: 0;
}

.cont .form-group input {
  flex: 1;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.cont .form-group .product-info-input {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.cont .form-group .message-input {
  color: #666;
}

/* 提示文字 */
.cont .logistics-info {
  text-align: center;
  font-size: 16px;
  color: #333;
  margin: 20px 0;
}

/* 提交按钮 */
.cont .submit-order {
  display: block;
  width: 60%;
  padding: 15px;
  background-color: #e7c717;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 auto 10px;
}

.cont .submit-order:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.cont .reset-order {
  display: block;
  width: 60%;
  padding: 12px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  margin: 0 auto;
}
</style>